import { Form } from 'react-bootstrap'
import { ConfigProvider, Switch as AntdSwitch } from 'antd'

export default function Switch(props) {

    const { label_name, name, checked, disabled, onChange, onBlur, error, mandatory, checked_label, unchecked_label } = props

    return (
        <Form.Group className="mb-2" controlId={name}>
            {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
            <div className="d-flex align-items-center gap-2" style={{ minHeight: '38px' }}>
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: '#006972',
                            fontFamily: 'Inter',
                        },
                    }}
                >
                    <AntdSwitch
                        checked={Boolean(checked)}
                        disabled={disabled}
                        onChange={onChange}
                        onBlur={onBlur}
                    />
                </ConfigProvider>
                <span className="form_label mb-0">
                    {checked ? (checked_label || 'True') : (unchecked_label || 'False')}
                </span>
            </div>
            {error}
        </Form.Group>
    )
}